import React, { useState } from "react";
import { Row, Col, Container, Card, Button } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import "./RentBotSubscription.scss";
import RentBotPaymentPanel from "./RentBotPaymentPanel";
import RentBotPremiumInfo from "./RentBotPremiumInfo";
import { useTranslation } from "react-i18next";

const RentBotSubscription = () => {
  const template = useSelector((state)=>state.subscription.template)
  const location = useLocation();
  const { search } = location;
  const query = queryString.parse(search);
  const plan = query.plan;
  const tier = query.tier;
  const history = useHistory();
  const {t} = useTranslation()

  //const [selectPl, setSelectMonthly] = useState(plan);

  return (
    <Container fluid className="sub">
      <Row className="py-2 justify-content-between sub-header">
        <a href="/" style={{ textDecoration: "none" }} className="ml-5">
          <span className="font-weight-bold" style={{ fontSize: "20px" }}>
            <img src="/images/logo.png" width="55" className="mr-2" />
            ForexHero
          </span>
        </a>
      </Row>

      <Row className="justify-content-around mt-5" noGutters>
        <Col xs={12} md={6} xl={5} className="px-0 px-sm-3 px-xl-5">
        <Button
            style={{ marginBottom: 10 }}
            className="py-2"
            variant="primary"
            onClick={() => history.goBack()}
          >{t("back")}</Button>
          <RentBotPremiumInfo readOnly  template={template} plan={plan}/>
        </Col>
        <Col
          xs={12}
          md={6}
          xl={5}
          className="px-0 px-sm-3 px-xl-5 mt-5 mt-md-0"
          style={{ maxWidth: 800 }}
        >
          <RentBotPaymentPanel
            template={template}
            plan={plan}
            //hideSelection={monthly != null}
            //onChange={setSelectMonthly}
            //tier={tier}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default connect(null)(RentBotSubscription);
